import _ from 'lodash';

export const DEFAULT_STATE = {};

export default function (venueCache) {
    return _.keyBy(_.flatten(_.map(venueCache, 'subVenues')), 'id');
}
